export const JOB_TYPES = [
  { label: 'All', value: '' },
  { label: 'Part Time', value: 'Part Time' },
  { label: 'Contract', value: 'Contract' },
  { label: 'Full Time', value: 'Full Time' },
  { label: 'Permanent', value: 'Permanent' },
];

export const EXPERIENCE_LEVELS = [
  { label: 'All Levels', value: '' },
  { label: 'Entry Level', value: '0' },
  { label: '1+ Years of Experience', value: '1' },
  { label: '2+ Years of Experience', value: '2' },
  { label: '4+ Years of Experience', value: '4' },
  { label: '6+ Years of Experience', value: '6' },
  { label: '8+ Years of Experience', value: '8' },
  { label: 'More than 10 Years of Experience', value: '10' },
];
